import React from 'react';
import { AlertTriangle, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { toast } from 'sonner';

const VerificationBanner = ({ user, onResend }) => {
  const [isResending, setIsResending] = React.useState(false);

  const handleResend = async () => {
    setIsResending(true);
    try {
      await onResend();
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send verification email');
    } finally {
      setIsResending(false);
    }
  };

  if (user?.email_verified) {
    return null;
  }

  return (
    <Card className="border-yellow-200 bg-yellow-50 mb-4">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 text-yellow-600 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm text-yellow-800">
              <strong>Please verify your email address.</strong> We sent a verification link to{' '}
              <span className="font-medium">{user?.email}</span>
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleResend}
            disabled={isResending}
            className="border-yellow-300 text-yellow-700 hover:bg-yellow-100"
          >
            <Mail className="h-4 w-4 mr-1" />
            {isResending ? 'Sending...' : 'Resend'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default VerificationBanner;